import { render, staticRenderFns } from "./DxWarehouse.vue?vue&type=template&id=56eb1a78&scoped=true&"
import script from "./DxWarehouse.vue?vue&type=script&lang=js&"
export * from "./DxWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./DxWarehouse.vue?vue&type=style&index=0&id=56eb1a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb1a78",
  null
  
)

export default component.exports